import { create } from 'zustand';

const useUI = create(set => ({
	swiper: null,
	setSwiper: swiper => set({ swiper })
}));

export default useUI;
